<template>
   <div>
    <div class="row d-flex justify-content-center">
      <div class="col-md-10 mr-auto ml-auto">
        <div class="card">
          <div class="card-header">
            <h4 class="title">EMS contract</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                If you want to create an EMS contract, you will have to enter the VAT number of your customer below. <br>
                After that, you will be redirected to the EMS interface, once you have completed the EMS form,
                you will have the possibility to auto complete the form for the next contract you will create for this customer
                <br><br><br>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <fg-input type="text"
                      label="VAT"
                      placeholder="VAT"
                      v-model="request.vat">
                </fg-input>
              </div>
              <div class="col-md-2" style="margin-top:auto">
                <button type="submit" class="btn btn-info btn-fill btn-wd" @click.prevent="sendRequest">
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  export default {
    components: {
    },
    data() {
      return {
        request: {
          vat: "",
          user_id: localStorage.id
        }
        
      }
    },
    methods: {
      sendRequest() {
        if(this.request.vat != '' && this.request.vat.length >= 10 ) {
          this.$http({
            method: 'post',
            url: 'https://e-contracts.eu/contract/ems',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            params: this.request,
          }).then(response => (
                 this.$router.push({ path: `/search/contracts` }),
                 window.open('https://boarding-sandbox.emspay.eu/start-boarding', '_blank')
          )).catch(err => {
            this.$notify({
              message: 'Impossible to generate your request',
              type: 'danger',
              horizontalAlign: 'center',
              verticalAlign: 'top'
            })
          })
        } else {
          this.$notify({
            message: 'Fill the form',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        }
    }
  }
}

</script>
<style>

</style>
